import { useCallback } from 'react';
import { get, isNil, omitBy } from 'lodash';
import { usePermissions } from '@lumahealthhq/ui-model';
import { useLogger } from '@lumahealthhq/ui-utils';
import useNavigate from './useNavigate';
import useProductsMap from './useProductsMap';
import useRoutingMap from './useRoutingMap';
export default function useNavigateToModule() {
  var logger = useLogger();
  var navigate = useNavigate();
  var _usePermissions = usePermissions(),
    hasAccessToProduct = _usePermissions.hasAccessToProduct;
  var productsMap = useProductsMap();
  var routingMap = useRoutingMap();
  var navigateToModule = useCallback(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (module, params, options) {
    var modulePathname = get(routingMap, module);
    if (!modulePathname) {
      logger.warn("No route configured for \"".concat(module, "\". Current routingMap:"), routingMap);
    }
    var moduleProducts = productsMap[module] || [];
    var hasAccess = hasAccessToProduct(moduleProducts);
    if (!hasAccessToProduct(moduleProducts)) {
      logger.warn("User has no access to \"".concat(module, "\". Products required:"), moduleProducts);
    }
    logger.debug('navigate', {
      module: module,
      modulePathname: modulePathname,
      params: params,
      moduleProducts: moduleProducts,
      hasAccess: hasAccess
    });
    return navigate({
      module: module,
      modulePathname: modulePathname,
      // Avoid passing "undefined" and "null" as URL parameters
      params: params && omitBy(params, isNil),
      moduleProducts: moduleProducts,
      hasAccess: hasAccess,
      debounced: options == null ? void 0 : options.debounced,
      target: options == null ? void 0 : options.target
    });
  }, [navigate, hasAccessToProduct, logger, productsMap, routingMap]);
  return navigateToModule;
}